import { render, staticRenderFns } from "./employeeView.vue?vue&type=template&id=1f438120"
import script from "./employeeView.vue?vue&type=script&lang=js"
export * from "./employeeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports